import React from "react";
import footerlogo from "../assets/images/footer-logo.png";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import newslettervalidationSchema from "../assets/validation/newsletter.js";
import axios from "axios";


function Footer() {
  return (
    <>
      <footer className="footer pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="footer-logo-block">
                <div className="logo">
                  <img src={footerlogo} alt="Logo" className="img-fluid" />
                </div>
                <div className="social-menu py-4">
                  <span className="flex-center">
                    <Link to="#">
                      <i className="fa-brands fa-instagram"></i>
                    </Link>
                  </span>
                  <span className="flex-center">
                    <Link to="#">
                      <i className="fa-brands fa-facebook"></i>
                    </Link>
                  </span>
                  <span className="flex-center">
                    <Link to="#">
                      <i className="fa-brands fa-linkedin"></i>
                    </Link>
                  </span>
                </div>
                <div className="footer-about">
                  <p>
                    {" "}
                    Entegation Technologies LLC. aims to empower organizations
                    to thrive in the digital era.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 ps-lg-5">
              <div className="footer-menu">
                <ul className="list-unstyled">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/careers">Career</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="location">
                <p>
                  {" "}
                  1702 Cort Ln, <br />
                  Allen TX 75013
                </p>
                <Link to="tel:6693385227" style={{ textDecoration: "none" }}>
                  <p className="theme-color pt-2"> (669) 338-5227 </p>
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="footer-contact">
                <h1>Stay in Touch</h1>
                <p className="py-4">
                  {" "}
                  Subscribe to our newsletter and never miss our news.{" "}
                </p>
                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={newslettervalidationSchema}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    axios
                    .post(
                      "http://localhost:5000/api/send-newsletter",
                      values)
                      .then((response) => {
                        alert(
                          "Subscribed successfully!!"
                        );
                        console.log(response.data, ">>>>>>>>>>");
                      })
                      .catch((error) => {
                        alert("Error sending email!");
                        console.error(error);
                      })
                      .finally(() => {
                        setSubmitting(false);
                        resetForm();
                      });
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form action="" className="subscribe d-flex">
                      <ErrorMessage
                        name="email"
                        component="div"
                        style={{ color: "red", marginTop: "5px" }}
                      />
                      
                      <Field
                        name="email"
                        type="text"
                        className="form-control"
                      />

                      <button className="btn btn-theme">Subscribe</button>
                      
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright text-center py-5">
          <p>&copy; Entegation Technologies. All Rights Reserved 2024.</p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
